import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery, useQuery } from '@apollo/client';
import { EnrollmentPeriod } from 'types/enrollmentService';
import { GET_ENROLLMENT_PERIOD_BY_ID } from 'api/queries/enrollmentService';
import { Group } from 'types/groupService';
import { GROUP_BY_ID } from 'api/queries/groupService';
import { createStyles } from './styles';

const TextWithCompanyName: React.FC = () => {
  const classes = createStyles();
  const { periodId } = useParams<{ periodId: string }>();

  const getEnrollmentPeriodQuery = useLazyQuery<{
    getEnrollmentPeriod: EnrollmentPeriod;
  }>(GET_ENROLLMENT_PERIOD_BY_ID, {
    variables: { periodId },
  });

  const getGroupByIdQuery = useQuery<{
    groupById: Group;
  }>(GROUP_BY_ID, {
    skip: !getEnrollmentPeriodQuery[1].data?.getEnrollmentPeriod,
    variables: { id: getEnrollmentPeriodQuery[1].data?.getEnrollmentPeriod.groupId },
  });

  useEffect(() => {
    void getEnrollmentPeriodQuery[0]();
  }, [getEnrollmentPeriodQuery[0]]);

  return (
    <div className={classes.fieldText}>
      <p>
        On behalf of, {getGroupByIdQuery.data?.groupById.name} and with the authority to act on behalf of this business,
        I understand and consent to the following:
      </p>
    </div>
  );
};

export default TextWithCompanyName;
